import React from 'react';
import styled from '@cthings.co/styled-components';
import { Text, TextType } from '@bit/first-scope.text';
import { Modal } from '@bit/first-scope.modal';
import { ModalContainer } from '@bit/first-scope.modal-container';
import { CommonButton } from '@cthings.co/buttons';
import { media } from '@cthings.co/styles-utils';
import { InfoIcon } from '../../../../../qualityModal/components/infoIcon/InfoIcon';
import { useTheme } from '@cthings.co/styled-components';

export type DeploymentDetailsInfoType = { fieldName: string; tooltipText: string; value: string };

const StyledModal = styled(Modal)`
  & > div {
    ${media.phone} {
      width: 100%;
    }
  }
` as any; // @TODO fix type

const StyledModalContainer = styled(ModalContainer)`
  width: 527px;
  height: max-content;
  padding: 25px 24px;
  display: flex;
  align-items: flex-start;

  ${media.phone} {
    width: 100%;
    position: fixed;
    padding: 24px 16px 18px;
    bottom: 0;
    border-radius: 16px 16px 0 0;
  }
`;

const InfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

const InfoRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;

const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const DeploymentDetailsModal = ({
  infoArr,
  closeModal,
  isOpenModal,
  languageStrings,
}: {
  infoArr: DeploymentDetailsInfoType[];
  closeModal: () => void;
  isOpenModal?: boolean;
  languageStrings?: any;
}) => {
  const theme = useTheme();
  const { black1, gray1, gray2 } = theme.colors;

  return (
    <StyledModal isOpenModal={isOpenModal}>
      <StyledModalContainer>
        <Text type={TextType.SEMITITLE} color={black1} fontSize={'18px'} weight={'700'} margin={'0 0 6px 0'}>
          {languageStrings.deploymentDetailsModalTitle}
        </Text>
        <InfoWrapper>
          {infoArr.map((item: DeploymentDetailsInfoType, index: number) => {
            const { fieldName, tooltipText, value } = item;
            return (
              <InfoRow key={index}>
                <TooltipWrapper>
                  <Text
                    type={TextType.TEXT_14_BLACK}
                    color={gray1}
                    fontSize={'14px'}
                    weight={'500'}
                    margin={'0 5px 0 0'}
                  >
                    {fieldName ? fieldName : 'N/A'}
                  </Text>
                  <InfoIcon tooltip={tooltipText} />
                </TooltipWrapper>
                <Text type={TextType.TEXT_14_BLACK} color={value ? gray1 : gray2} fontSize={'14px'} weight={'400'}>
                  {value ? value : 'N/A'}
                </Text>
              </InfoRow>
            );
          })}
        </InfoWrapper>
        <ButtonWrapper>
          <CommonButton width={'104px'} height={'32px'} onClick={closeModal}>
            {languageStrings.closeButtonValue}
          </CommonButton>
        </ButtonWrapper>
      </StyledModalContainer>
    </StyledModal>
  );
};
